<template>
  <el-dialog title="Cadastrar Pagamento de Comissão" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" @open="reset" width="30%">
    <el-form size="small" label-position="top">
      <el-form-item label="Corretor" style="width: 100%">
        <el-input v-if="!comissao.comissaoImobiliaria" v-model="comissao.corretor.nome" style="width: 100%" readonly/>

        <el-input value="IMOBILIÁRIA" v-else readonly></el-input>
      </el-form-item>

      <el-row :span="24" :gutter="4">
      <el-col :span="9">
        <el-form-item label="Previsão de Pgto">
          <el-date-picker
            v-model="dataPagamento"
            v-mask="'##/##/####'"
            type="date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
            style="width: 100%"
          />
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="Valor">
          <div class="el-input el-input--small">
            <money v-model="valor" v-bind="money" class="el-input__inner"/>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="7">
        <el-form-item label="Parcelas">
          <el-input v-model="parcelas"></el-input>
        </el-form-item>
      </el-col>
      </el-row>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="adicionarPagamento" type="primary" round class="btn-box-shadow">Adicionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Money } from "v-money";
import Util from "../../../util/funcoes.js";

export default {
  components: {
    Money
  },
  props: {
    visibility: Boolean,
    comissao: {
      corretor: {
        nome: ''
      }
    }
  },
  data() {
    return {
      dataPagamento: Util.hoje(),
      pagamentoComissao: {},
      parcelas: 1,
      valor: 0,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    ...mapState("vendasContratosStore", {
      venda(state) {
        return state.vendaSelecionada;
      },
      usuariosDisponiveis() {
        return this.$store.state.vendasContratosStore.usuariosDisponiveis;
      }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasContratosStore", ["adicionarPagamentoComissao"]),
    adicionarPagamento() {
      this.pagamentoComissao = { 
        id: this.comissao.id,
        dataPrevisaoPagamento: this.dataPagamento,
        valorPago: this.valor,
        parcelas: this.parcelas,
        venda: { id: this.venda.id },
        comissao: { id: this.comissao.id },
        corretor: { id: this.comissao.corretor ? this.comissao.corretor.id : 0 }
      };

      this.showLoading();
      this.adicionarPagamentoComissao(this.pagamentoComissao).then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            this.$message.success(response.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(response.mensagem);
            break;
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    reset() {
      this.parcelas = 1;
      this.valor = 0;
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

